export const FISCAL_ADVISOR_FLAG = 'fiscal-advisor';
